import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import toast from "react-hot-toast";
import useAuth from "./useAuth";
import { useTenantSelection } from "../features/TenantSelection/contexts/TenantSelection";

const useQueryParamActions = () => {
  const { currentUser } = useAuth();
  const { open: openTenantSelector } = useTenantSelection();
  const [searchParams, setSearchParams] = useSearchParams();
  const handled = useRef(false);

  useEffect(() => {
    if (!currentUser || handled.current) return;
    handled.current = true;

    const toastMessage = searchParams.get("toast");
    const urlTenantIdParam = searchParams.get("tenantId");

    if (toastMessage) {
      toast(toastMessage);
    }

    if (urlTenantIdParam && currentUser._isInternalUser) {
      const urlTenantId = parseInt(urlTenantIdParam, 10);
      if (!isNaN(urlTenantId) && urlTenantId !== currentUser.tenantId) {
        openTenantSelector({ prefillTenantId: urlTenantIdParam });
      }
    }

    if (toastMessage || urlTenantIdParam) {
      const next = new URLSearchParams(searchParams);
      next.delete("toast");
      next.delete("tenantId");
      setSearchParams(next, { replace: true });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser]);
};

export default useQueryParamActions;
